import { create } from "zustand";
import { persist } from "zustand/middleware";

export type AdminColorMode = "light" | "dark";

const STORAGE_KEY = "aivpn-admin-theme";

export const useThemeStore = create<{
  mode: AdminColorMode;
  setMode: (m: AdminColorMode) => void;
  toggle: () => void;
}>()(
  persist(
    (set, get) => ({
      mode: "light",
      setMode: (m) => set({ mode: m }),
      toggle: () =>
        set({ mode: get().mode === "light" ? "dark" : "light" }),
    }),
    { name: STORAGE_KEY }
  )
);
